import React from 'react';
import { Typography, Box } from '@mui/material';
import { Link } from '@mui/material';           // MUI Link
import { Link as RouterLink } from 'react-router-dom';
import { APP_COPYRIGHT_YEARS } from '../../config.js'; // Import the copyright years from config.js

function Footer() {
  // formerly: https://mobidawg.appspot.com/ 
  return (
    <Box component="footer" sx={{ py: 2, px: 2, mt: 'auto', borderTop: '1px solid', borderColor: 'divider' }}>
      <Typography variant="body2" color="text.secondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://mobidawg.com/">
          mobidawg, llc
        </Link>{ "  " + APP_COPYRIGHT_YEARS }
      </Typography>
    </Box>
  );
}

export default Footer;